import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled, { css } from "styled-components";


export const NotificationsHead = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr) ${toRem(36)};
  column-gap: ${toRem(12)};
  position: relative;
  max-width: ${toRem(640)};

  .input {
    min-width: ${toRem(0)};
    max-width: 100%;

    .input__field {
      max-width: calc(100% - ${toRem(45)});
    }
  }

  .dropdown-menu-root,
  .popover__root {
    max-width: 100%;
  }

  .dropdown {
    width: 100%;
    max-width: calc(100vw - ${toRem(32)});
  }

  .dropdown-menu {
    max-width: calc(100vw - ${toRem(32)});
    width: 100%;
  }
`

export const ChipsWrapper = styled.div`
  display: flex;
  gap: ${toRem(8)};
  max-width: 100vw;
  overflow: auto hidden;
  margin: 0 ${toRem(-16)};
  padding: ${toRem(16)};
  grid-column: 1 / span 3;
`

type NotificationsWrapperProps = {
  $isModal?: boolean;
}
export const NotificationsWrapper = styled.div<NotificationsWrapperProps>`
  padding-bottom: ${props => props.$isModal ? toRem(60) : 0};
  height: 100%;
`

type NotificationsListWrapperProps = {
  $isModal?: boolean;
  $isVidget?: boolean;
}
export const NotificationsListWrapper = styled.div<NotificationsListWrapperProps>`
  max-height: ${props => {
    // props.$isModal ? `calc(100% - ${toRem(148)})` : `calc(100dvh - ${toRem(252)})`
    if (props.$isModal) {
      return `calc(100% - ${toRem(148)});`
    }
    if (props.$isVidget) {
      return `100%;`
    }
    return `calc(100dvh - ${toRem(252)});`
  }};

  //${props => props.$isVidget && css`padding: ${toRem(24)};`}
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: ${COLORS.NEUTRAL.MUTED} ${COLORS.NEUTRAL.CONTAINER_DEFAULT};

  @media (any-hover: none){
    scrollbar-width: none;
  }
`

export const NotificationsListTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${toRem(8)};
  font-weight: 700;
  font-size: ${toRem(16)};
  line-height: ${24 / 16};
  &:not(:last-child) {margin-bottom: ${toRem(16)};}
`

export const NotificationItemBlock = styled.div`
  display: flex;
  border-radius: ${toRem(12)};
  overflow: hidden;
  width: max(100%, fit-content);
  max-width: ${toRem(592)};
  cursor: pointer;
  &:not(:last-child) {margin-bottom: ${toRem(8)};}
`

type NotificationItemIconProps = {
  $bg: string
}
export const NotificationItemIcon = styled.div<NotificationItemIconProps>`
  padding: ${toRem(16)} ${toRem(12)};
  background-color: ${props => props.$bg};

  svg {
    width: ${toRem(24)};
    height: ${toRem(24)};
  }
`

type NotificationItemBodyProps = {
  $bg: string;
}
export const NotificationItemBody = styled.div<NotificationItemBodyProps>`
  padding: ${toRem(16)};
  gap: ${toRem(12)};
  background-color: ${props => props.$bg};
  line-height: ${20 / 14};
  flex: 1 1 auto;

  display: grid;
  grid-template-columns: auto ${toRem(75)};
`

export const NotificationItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(4)};
  flex: 1 1 auto;
`

export const NotificationItemTitle = styled.h3`
  font-weight: 500;
  font-size: ${toRem(14)};
  color: ${COLORS.FG.DEFAULT};
  grid-row-start: 1;
`

export const NotificationItemText = styled.p`
  grid-row-start: 2;
  grid-column: span 2;
  color: ${COLORS.FG.MUTED};
`

export const NotificationItemDate = styled.div`
  text-align: right;
  color: ${COLORS.FG.MUTED};
  font-size: ${toRem(12)};
  line-height: ${16 / 12};
  grid-row-start: 1;
  grid-column-start: 2;
`

export const NotificationItemActions = styled.div`
  display: flex;
  gap: ${toRem(16)};
  grid-row-start: 3;
  grid-column: span 2;
`

export const NotificationItemLink = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: ${toRem(13)};
  line-height: ${20 / 13};
  color: ${COLORS.ACCENT.DEFAULT};
  vertical-align: middle;
  cursor: pointer;
  span {
    padding-top: ${toRem(2)};
  }

  @media (any-hover: hover){
    &:hover{
      text-decoration: underline;
    }
  }
`

export const NotificationItemMarkRead = styled.a`
  display: flex;
  align-items: center;
  gap: ${toRem(4)};
  font-weight: 500;
  font-size: ${toRem(13)};
  line-height: ${20 / 13};
  vertical-align: middle;
  cursor: pointer;
  margin-left: auto;
  text-decoration: underline;
  text-align: right;
  
  span {
    padding-top: ${toRem(2)};
  }

  @media (any-hover: hover){
    &:hover{
      text-decoration: none;
    }
  }
`